export default "be07dec24cdd47b1.png"